import { i18n } from "@lingui/core";
import { t } from "@lingui/macro";
import type config from "~/config/lingui.config";
import { useGlobals } from "~/hooks/useGlobals";

export function getLanguages(): Array<{
  key: (typeof config.locales)[number];
  label: string;
}> {
  return [
    { key: "en", label: t`English` },
    { key: "fr", label: t`French` },
  ];
}

export async function loadCatalog(locale: string) {
  const { messages } = await import(`../../locales/${locale}.po`);

  return i18n.loadAndActivate({ locale, messages });
}

/**
 * Get the locale returned by the global window object.
 */
export function useLocale(): string {
  const { language } = useGlobals() || {};

  return language ?? "en";
}
